/**
 * Maison scroll reveal (content-only).
 * Usage: add `data-maison-reveal` to any element you want to fade in on scroll.
 * Optional: set `style="--maison-reveal-order: N"` for staggered delays.
 */
(function () {
  const VISIBLE_CLASS = 'maison-reveal--visible';
  const SELECTOR = '[data-maison-reveal]';

  // Tunables via CSS variables on :root (or any ancestor, e.g. section wrapper):
  //   --maison-reveal-root-margin-desktop: 0px 0px 20% 0px;
  //   --maison-reveal-root-margin-mobile:  0px 0px 30% 0px;
  const DEFAULT_ROOT_MARGIN_DESKTOP = '0px 0px 20% 0px';
  const DEFAULT_ROOT_MARGIN_MOBILE = '0px 0px 30% 0px';
  const MOBILE_MQ = '(max-width: 749px)';

  function readCssVar(name) {
    return (getComputedStyle(document.documentElement).getPropertyValue(name) || '').trim();
  }

  function getObserverOptions() {
    const isMobile = window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
    const rootMargin = isMobile
      ? (readCssVar('--maison-reveal-root-margin-mobile') || DEFAULT_ROOT_MARGIN_MOBILE)
      : (readCssVar('--maison-reveal-root-margin-desktop') || DEFAULT_ROOT_MARGIN_DESKTOP);

    return { threshold: 0, rootMargin };
  }

  const observed = new WeakSet();
  let observer = null;

  function reveal(el) {
    el.classList.add(VISIBLE_CLASS);
  }

  function getObserver() {
    if (observer) return observer;
    if (!('IntersectionObserver' in window)) return null;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, getObserverOptions());

    return observer;
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const els = Array.from(scope.querySelectorAll(SELECTOR));
    if (!els.length) return;

    const io = getObserver();
    if (!io) {
      els.forEach(reveal);
      return;
    }

    // Wait a frame so layout is settled (helps with sections + sliders).
    requestAnimationFrame(() => {
      els.forEach((el) => {
        if (observed.has(el)) return;
        observed.add(el);
        io.observe(el);
      });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(() => init(document));
  window.addEventListener('load', () => init(document), { once: true });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:reorder', () => init(document));
  }
})();

